import axios from "axios";
import {
  setCredentials,
  resetCredentials,
} from "../redux/reducers/authReducer";
import store, { persistor } from "../redux/store/store";

const api = axios.create({
  baseURL: "",
});

api.interceptors.request.use((config) => {
  const token = store.getState().auth.accessToken;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    const newToken = response.headers["x-access-token"];
    if (newToken) {
      // console.log("🔁 New token received:", newToken);
      store.dispatch(setCredentials({ accessToken: newToken }));
      console.log("✅ Updated Redux state:", store.getState().auth);
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // If 401 AND we haven't retried this request yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      const currentToken = store.getState().auth.accessToken;
      const sentToken = originalRequest.headers.Authorization?.replace(
        "Bearer ",
        "",
      );

      // If another request already refreshed the token, retry with the new one
      if (currentToken && currentToken !== sentToken) {
        //    console.log("🔄 Retrying request with refreshed token");
        originalRequest._retry = true;
        originalRequest.headers.Authorization = `Bearer ${currentToken}`;
        return api(originalRequest);
      }

      // Otherwise, it's a real auth failure → logout
      console.warn("Real 401 — logging out");
      store.dispatch(resetCredentials());
      await persistor.purge();
      localStorage.clear();
      window.location.href = "/";
    }

    return Promise.reject(error);
  },
);

export default api;
